import { AxiosError } from 'axios';
import * as Interfaces from 'interfaces';
import * as api from 'utils/api';

export class ABNService {
  /**
   * api request adapter object
   */
  private adapter: api.Adapter;

  constructor(baseURL: string) {
    this.adapter = new api.Adapter({
      baseURL,
      responseType: 'json',
      headers: {
        timeout: 60 * 10 * 1000,
        'content-type': 'application/json',
        accept: 'application/json'
      }
    });
    // This binding maintains the value of this inside these methods during future calls.
    this.getABNDetails = this.getABNDetails.bind(this);
  }

  /**
   * Retrieve the full details of the ABN
   * @param abnNo unique abn number
   */
  async getABNDetails(abnNo: string): Promise<Interfaces.API.ApiABNDetails> {
    const url = `/${abnNo.replace(/\s/g, '')}`;
    try {
      const response = await this.adapter.getValue<Interfaces.API.ApiABNDetails>(url);
      return response.data;
    } catch (e) {
      const err = e as AxiosError;

      if (err.response?.status === 404) {
        return {};
      }
      throw err;
    }
  }
}
